<atl-default-modal [headerData]="headerData">
  <div class="video-modal__empty-video">
    <img src="assets/video-empty.svg" alt="video-empty">
    <span>{{'Shared.Description.Not_supporting_video' | translate}}</span>
  </div>
</atl-default-modal>
